import { render, staticRenderFns } from "./SingleCourseDetail.vue?vue&type=template&id=8e8b755e&scoped=true"
import script from "./SingleCourseDetail.vue?vue&type=script&lang=js"
export * from "./SingleCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./SingleCourseDetail.vue?vue&type=style&index=0&id=8e8b755e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8b755e",
  null
  
)

export default component.exports